/* eslint-disable @typescript-eslint/no-explicit-any */
import { ToGradeTextString } from '@utils/getGradeFromId'
import { Col, Flex, Row, Spin } from 'antd'

import { useFramework } from '@suntex.fim/framework'

/**
 * returns JSX for team summary
 */
function TeamSummary({
  isLoading,
  summaryRecordData,
  remainingLicenses,
  totalLicenses
}: {
  isLoading: boolean
  summaryRecordData: any
  remainingLicenses: number
  totalLicenses: number
}) {
  const { localization } = useFramework()
  return (
    <Flex
      className={`main-dashboard ${isLoading ? 'loading-back' : ''}`}
      vertical
    >
      <Flex>
        <h4 className="title">Team Summary</h4>
      </Flex>
      <Row>
        {isLoading ? (
          <Flex flex="auto" justify="center" align="center">
            <Spin />
          </Flex>
        ) : (
          <>
            <Col className="stat">
              <span className="label">Team</span>
              <span className="numbers">{summaryRecordData?.info?.name}</span>
            </Col>
            <Col className="stat">
              <span className="label">Current Team Size</span>
              <span className="numbers">
                {summaryRecordData?.info?.studentsPlaying}
              </span>
            </Col>
            <Col className="stat">
              <span className="label">{localization.text('Grade')}</span>
              <span className="numbers">
                {localization.text(
                  ToGradeTextString(summaryRecordData?.info?.grade)
                )}
              </span>
            </Col>
            <Col className="stat">
              <span className="label">Class</span>
              <span className="numbers">
                {summaryRecordData?.info?.className}
              </span>
            </Col>
            <Col className="stat">
              <span className="label">School</span>
              <span className="numbers">
                {summaryRecordData?.info?.schoolName}
              </span>
            </Col>
            <Col className="stat">
              <span className="label">Co-Teacher</span>
              <span className="numbers">
                {summaryRecordData?.coTeachers?.join(', ')}
              </span>
            </Col>
            <Col className="stat">
              <span className="label">Unassigned Licenses</span>
              <span className="numbers">
                {remainingLicenses} / {totalLicenses}
              </span>
            </Col>
          </>
        )}
      </Row>
    </Flex>
  )
}

export default TeamSummary
